/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse, HttpContext } from '@angular/common/http';
import { BaseService } from '../base-service';
import { OfferApiConfiguration } from '../offer-api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { PomClaimCategoriesResponseDtoDto } from '../models/pom-claim-categories-response-dto-dto';


/**
 * the Categories for claims API
 */
@Injectable({
  providedIn: 'root',
})
export class CategoriesForClaimsService extends BaseService {
  constructor(
    config: OfferApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation listForClaims
   */
  static readonly ListForClaimsPath = '/category/claim';

  /**
   * Get list of categories for claims
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `listForClaims()` instead.
   *
   * This method doesn't expect any request body.
   */
  listForClaims$Response(params: {
    language: string;
  },
  context?: HttpContext

): Observable<StrictHttpResponse<PomClaimCategoriesResponseDtoDto>> {

    const rb = new RequestBuilder(this.rootUrl, CategoriesForClaimsService.ListForClaimsPath, 'get');
    if (params) {
      rb.query('language', params.language, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json',
      context: context
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<PomClaimCategoriesResponseDtoDto>;
      })
    );
  }

  /**
   * Get list of categories for claims
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `listForClaims$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  listForClaims(params: {
    language: string;
  },
  context?: HttpContext

): Observable<PomClaimCategoriesResponseDtoDto> {

    return this.listForClaims$Response(params,context).pipe(
      map((r: StrictHttpResponse<PomClaimCategoriesResponseDtoDto>) => r.body as PomClaimCategoriesResponseDtoDto)
    );
  }

}
